type BooleanLike = boolean | number | string | null | undefined;

export interface SponsorFreeRegistrationInputs {
    sponsorLevel: number | string;
    traineeAndEarlyCareerDay?: BooleanLike;
    symposiums?: BooleanLike;
    sponsoredGuestSpeaker?: BooleanLike;
    additionalFreeRegistrations?: number | string | null;
}

const baseFreeRegistrations: Record<number, number> = {
    1: 0,
    2: 1,
    3: 1,
    4: 2,
    5: 3,
    6: 4,
    7: 6,
};

const isEnabled = (value: BooleanLike): boolean =>
    value === true || value === 1 || value === '1' || value === 'true';

export const calculateFreeRegistrations = ({
    sponsorLevel,
    traineeAndEarlyCareerDay,
    symposiums,
    sponsoredGuestSpeaker,
    additionalFreeRegistrations,
}: SponsorFreeRegistrationInputs): number => {
    const base = baseFreeRegistrations[Number(sponsorLevel)] ?? 0;
    const explicitAdditional = Number(additionalFreeRegistrations ?? 0);
    const additional =
        (isEnabled(traineeAndEarlyCareerDay) ? 1 : 0) +
        (isEnabled(symposiums) ? 1 : 0) +
        (isEnabled(sponsoredGuestSpeaker) ? 2 : 0) +
        (Number.isFinite(explicitAdditional) ? explicitAdditional : 0);

    return base + additional;
};
